const products = [
  {
    id: 1,
    name: "BOBIS VPN",
    tagline: "Privacy & Security",
    description:
      "Military-grade encryption for your iOS device. Browse anonymously, bypass geo-restrictions, and keep your data safe on any network with blazing-fast connection speeds.",
    features: ["256-bit AES Encryption", "No-Log Policy", "50+ Server Locations", "Kill Switch Protection"],
    accent: "#4a90d9",
    image:
      "https://public.readdy.ai/ai/img_res/b9a9b26158597cbe6c9391ead9f8fecf.jpg",
    icon: "ri-shield-keyhole-line",
  },
  {
    id: 2,
    name: "BOBIS Cleaner",
    tagline: "Performance & Storage",
    description:
      "Reclaim your iPhone's full potential. Intelligently detects junk files, duplicate photos, and unused caches to free up storage and keep your device running at peak performance.",
    features: ["Smart Junk Detection", "Duplicate Photo Finder", "Cache Cleaner", "Battery Optimizer"],
    accent: "#34c78a",
    image:
      "https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20showing%20storage%20optimization%20dashboard%2C%20circular%20progress%20indicators%2C%20clean%20white%20and%20green%20UI%20on%20light%20background%2C%20modern%20minimal%20mobile%20app%20design%2C%20professional%20app%20screenshot%20with%20storage%20stats%20and%20clean%20typography&width=600&height=800&seq=cleaner-product-001&orientation=portrait",
    icon: "ri-speed-up-line",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-16">
          <div>
            <span className="text-xs uppercase tracking-[0.25em] text-[#999] font-medium">/ Our Products</span>
            <h2 className="text-4xl md:text-5xl font-thin text-[#2A2A2A] mt-3 leading-tight">
              Built for iOS.<br />
              <span className="font-light text-[#555]">Designed for You.</span>
            </h2>
          </div>
          <p className="text-[#888] text-base font-light max-w-xs leading-relaxed md:text-right">
            Enhancing mobile security and user experience through thoughtful design.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className="group relative rounded-3xl overflow-hidden bg-white border border-gray-100 hover:-translate-y-1 transition-transform duration-300"
              style={{ boxShadow: "0 8px 40px rgba(0,0,0,0.06)" }}
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                {/* Tag */}
                <div
                  className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 rounded-full text-white text-xs font-medium"
                  style={{ background: `${product.accent}cc`, backdropFilter: "blur(8px)" }}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${product.icon} text-sm`} />
                  </div>
                  {product.tagline}
                </div>

                {/* Name overlay */}
                <div className="absolute bottom-4 left-5">
                  <h3 className="text-2xl font-semibold text-white">{product.name}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-[#666] text-sm leading-relaxed mb-5 font-light">{product.description}</p>

                <ul className="grid grid-cols-2 gap-2">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2 text-xs text-[#555]">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-emerald-500 text-sm" />
                      </div>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Accent bar */}
              <div
                className="absolute bottom-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: `linear-gradient(90deg, ${product.accent}, transparent)` }}
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
